import { Badge } from "@/components/design-system/badge";
import React from "react";

export interface AssignmentCardProps {
  courseTitle: string;
  status: "In Progress" | "Completed" | "New Feedback";
  unitName?: string;
  lessonName?: string;
  dateTime: string;
  onViewAssignment?: () => void;
}

const AssignmentCard: React.FC<AssignmentCardProps> = ({
  courseTitle,
  status,
  unitName,
  lessonName,
  dateTime,
  onViewAssignment,
}) => {
  // Get the appropriate background color for the status badge
  const getBadgeVariant = (status: string) => {
    switch (status) {
      case "NEW":
        return "primary";
      case "COMPLETED":
        return "success";
      case "REVIEW":
        return "warning";
      case "PENDING":
        return "danger";
      default:
        return "primary";
    }
  };

  return (
    <div
      className="border md:w-[314px] cursor-pointer w-full border-[#B5B5C3] rounded-[12px] p-[12px] hover:shadow-md transition-shadow"
      onClick={onViewAssignment}
    >
      <div className="flex items-center gap-2">
        {/* Course icon - using a placeholder circle with sound icon */}
        <div className="w-[33px] h-[33px] flex items-center justify-center">
          <img src="/images/audio.png" alt="Course Icon" />
        </div>

        {/* Course title and status */}
        <div className="flex-1">
          <h3 className="text-[18px] font-[600] text-[#161439]">
            {courseTitle}
          </h3>
        </div>
      </div>
      <Badge
        variant={getBadgeVariant(status)}
        className="py-[8px] px-[10px] h-[32px] min-w-[130px] my-[8px] rounded-[70px] text-[16px] font-[500]"
      >
        {status}
      </Badge>
      {/* Unit name */}
      {unitName && (
        <div className="mb-[12px] text-[16px] text-[#1C1A4A]">
          <span className="font-[500]">Unit Name:</span>{" "}
          <span className="font-[600]">{unitName}</span>
        </div>
      )}

      {/* Lesson name */}
      {lessonName && (
        <div className="mb-[12px] text-[16px] text-[#1C1A4A]">
          <span className="font-[500]">Lesson Name:</span>{" "}
          <span className="font-[600]">{lessonName}</span>
        </div>
      )}

      {/* Date and time */}
      <div className="text-[#929292] text-[16px] font-[500]">{dateTime}</div>
    </div>
  );
};

export default AssignmentCard;
